import MainLayout from "../components/SharedComponents/MainLayout";
import TermsAndConditions from "../components/Terms&ConditionsPageComponents/TermsAndConditions";

export default function TermsAndConditionsPage() {
    return (
      <div>
        <MainLayout>
          <TermsAndConditions />
        </MainLayout>
      </div>
    );
  }
  
